import AppUrls from '../config/AppUrls';


export const getCountryImage = countryCode => (countryCode
  ? `${AppUrls.resources.flags + countryCode.toUpperCase()}.svg`
  : `${process.env.PUBLIC_URL}/img/default-image.svg`);

export const getPaymentMethodImage = paymentMethodCode => (paymentMethodCode
  ? `${AppUrls.resources.paymentMethods}square/${paymentMethodCode.toUpperCase()}.svg`
  : `${process.env.PUBLIC_URL}/img/default-image.svg`);

export const getPayoutMethodImage = payoutMethodCode => (payoutMethodCode
  ? `${AppUrls.resources.payoutMethods}square/${payoutMethodCode.toUpperCase()}.svg`
  : `${process.env.PUBLIC_URL}/img/default-image.svg`);

export const getBankImage = (bankCode, countryIso) => (bankCode && countryIso
  ? `${AppUrls.resources.banks}${countryIso.toUpperCase()}_${bankCode}.svg`
  : `${process.env.PUBLIC_URL}/img/default-image.svg`);

export const handleErrorImgCountry = (e) => {
  e.target.src = `${process.env.PUBLIC_URL}/img/default-image.svg`;
};

export const handleErrorImgPaymentMethod = (e) => {
  e.target.src = `${process.env.PUBLIC_URL}/img/default-image.svg`;
};

export const buildPathWithParams = (path, params) => {
  let finalPath = path;
  Object.keys(params).forEach((key) => {
    finalPath = finalPath.replace(`:${key}`, params[key]);
  });
  // eslint-disable-next-line no-useless-escape
  return finalPath.replace(/\([^\)\(]*\)/, '');
};

export const buildPathWithQueryParams = (path, params) => {
  if (!params || Object.keys(params).length === 0) return path;
  
  const queryString = Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  
  return `${path}?${queryString}`;
};

export const getBase64WithHeaderBasedOnFilename = (image, fileName) => {
  if (!image || !fileName) {
    return null;
  }
  const splittedFileName = fileName.split('.');
  if (!splittedFileName) {
    return null;
  }
  const extension = splittedFileName[splittedFileName.length - 1];
  return `data:image/${extension.toLowerCase()};base64,${image}`;
};

export const ApiDocumentationCountries = 'https://docs.d24.com/api-documentation/cashouts-api/countries-validations/';